import React, { useEffect, useState } from "react";
import "../../../assets/css/Text.css";
import InputLabel from "./inputLabel";

interface TextAreaProps {
  title: string;
  name?: string;
  errorMsj?: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error: boolean;
  tooltip?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  maxChars?: number;
  characterCount?: boolean;
  height?: string;
  className?: string;
}

const TextArea: React.FC<TextAreaProps> = (props) => {
  const [inputValue, setInputValue] = useState(props.value || "");

  useEffect(() => {
    setInputValue(props.value || "");
  }, [props.value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.target;

    if (props.maxChars && value.length > props.maxChars) {
      return;
    }

    setInputValue(value);

    if (props.onChange) {
      props.onChange(event);
    }
  };

  const height = props.height || "h-[240px]";

  return (
    <div
      className={`flex flex-col gap-2 md:gap-[.625rem] self-stretch items-start `}
    >
      {(props.title || props.tooltip) && (
        <div className="flex gap-2 w-full">
          <InputLabel
            name={props.name || ""}
            title={props.title}
            required={props.required}
            tooltip={props.tooltip}
          />
        </div>
      )}
      <textarea
        name={props.name}
        value={inputValue}
        placeholder={props.placeholder}
        onChange={handleInputChange}
        disabled={props.disabled}
        className={`  ${height} ${props.error ? "text-primary" : "text-input-gray"} ${props.className}
        ${props.error ? "errorInput" : props.maxChars && inputValue.length >= props.maxChars ? "!outline !outline-1 !outline-primary" : " "}`}
      />

      <span
        className={`flex flex-wrap items-center ${!props.error && "hidden"} text-base font-medium text-primary`}
      >
        {props.errorMsj}
      </span>

      {props.characterCount && (
        <p className="w-fit flex ml-auto text-gray-font text-base">
          Characters:{" "}
          {props.maxChars
            ? `${inputValue.length}/${props.maxChars}`
            : props.value?.length || 0}
        </p>
      )}
    </div>
  );
};

export default TextArea;
